import type { ReactNode } from 'react'

/**
 * Tekst i anførselstegn - knapper, felter og faner - vises med fed, så den er let at
 * finde igen på skærmen. Anførselstegnene fjernes.
 */
export function rich(text: string): ReactNode[] {
  return text.split(/"([^"]+)"/g).map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : part))
}
